const IMAGES = {
    client1: require('../img/clients/client1.png'),
    client2: require('../img/clients/client2.png'),
    client3: require('../img/clients/client3.png'),
    client4: require('../img/clients/client4.png'),
    client5: require('../img/clients/client5.png'),
    client6: require('../img/clients/client6.jpg'),
    client7: require('../img/clients/client7.png'),
    client8: require('../img/clients/client8.jpg'),
    client9: require('../img/clients/client9.png'),
    client10: require('../img/clients/client10.png'),
    client11: require('../img/clients/client11.jpg'),
    client12: require('../img/clients/client12.png'),
    client13: require('../img/clients/client13.png'),
    client14: require('../img/clients/client14.png'),
    client15: require('../img/clients/client15.jpg'),
    client16: require('../img/clients/client16.png'),
    client17: require('../img/clients/client17.jpg'),
    client18: require('../img/clients/client18.png'),
    client19: require('../img/clients/client19.png'),
    client20: require('../img/clients/client20.png'),
    client21: require('../img/clients/client21.png'),
    client22: require('../img/clients/client22.jpg'),
    client23: require('../img/clients/client23.jpg'),
    client24: require('../img/clients/client24.jpg'),
    client25: require('../img/clients/client25.jpg'),
    client26: require('../img/clients/client26.jpg'),
    client27: require('../img/clients/client27.png'),
    client28: require('../img/clients/client28.jpg'),
    client29: require('../img/clients/client29.png'),
    client30: require('../img/clients/client30.png'), 
    client31: require('../img/clients/client31.jpg'), 
    client32: require('../img/clients/client32.jpg'), 
    client33: require('../img/clients/client33.jpg'), 
    client34: require('../img/clients/client34.png'), 
    client35: require('../img/clients/client35.png'), 
    client36: require('../img/clients/client36.jpg'), 
    client37: require('../img/clients/client37.jpg'), 
    client38: require('../img/clients/client38.png'), 
    client39: require('../img/clients/client39.png'), 
    client40: require('../img/clients/client40.png'), 
    client41: require('../img/clients/client41.png'), 
    client42: require('../img/clients/client42.png'), 
    client43: require('../img/clients/client43.png'), 
    client44: require('../img/clients/client44.png'), 
    client45: require('../img/clients/client45.png'), 
   
}
export default IMAGES;